// extracted by mini-css-extract-plugin
export var component = "TagsList-module--component--e3673";
export var fadePop = "TagsList-module--fade-pop--27088";
export var growHeightIn = "TagsList-module--grow-height-in--d8188";
export var vertical = "TagsList-module--vertical--a3639";